module.exports = __webpack_public_path__ + "img/man.46d86c28.png";